export default __webpack_public_path__ + "static/media/all-wall.7e675eec.png";